var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrunchbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.6 0h-19.2a2.41 2.41 0 0 0 -2.4 2.4v19.2a2.41 2.41 0 0 0 2.4 2.4h19.2a2.41 2.41 0 0 0 2.4-2.4v-19.2a2.41 2.41 0 0 0 -2.4-2.4zm-14.555 14.465a2.11 2.11 0 0 0 2.795-1.045h1.66a3.69 3.69 0 1 1 0-1.75h-1.66a2.11 2.11 0 1 0 -2.795 2.795zm11.345.845a3.55 3.55 0 0 1 -1.06.63 3.68 3.68 0 0 1 -3.39-.38v.38h-1.51v-10.57h1.5v4.11a3.74 3.74 0 0 1 1.8-.63h.27a3.67 3.67 0 0 1 2.39 6.46zm-.223-2.766a2.104 2.104 0 1 1 -4.207 0 2.104 2.104 0 0 1 4.207 0z",
    fill: "#A5AEB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrunchbase);
export default __webpack_public_path__ + "static/media/crunchbase.ed6fc26d6ea26db7a7fa4d936fb75d4b.svg";
export { ForwardRef as ReactComponent };